import React, { Component } from 'react';
import Button from "../buttons/Button";
import './SubscribeBanner.scss';

class SubscribeBanner extends Component {
    render() {
        return (
            <div className="sign-up-banner">
                <h2 className="sign-up-banner__title">
                    Join the LIVE <i>large</i> family and save 15%
                </h2>

                <Button
                    toUrl="/sign-up"
                    color="purple"
                    title="SIGN UP"
                    centered
                    newTab
                />
            </div>
        );
    }
}

export default SubscribeBanner;
